import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { PluginListenerHandle } from '@capacitor/core';
import { InputAppAPIHelperUtil } from '@monorepo/utils';
import { Platform } from '@ionic/angular';
import NFCReaderPlugin, { TNFCConnectionState } from './nfc-reader';
import { TScanModes, TScannedRFIDTagInfo } from '../../input-app/rfid-tag-reader.service';

@Injectable({
  providedIn: 'root',
})
export class NFCReaderService {
  private NFCConnectionStateEmitter = new BehaviorSubject<TNFCConnectionState>({
    connectionState: 'DISCONNECTED',
  });
  private NFCScannedData = new Subject<TScannedRFIDTagInfo>();
  private connectionListener?: PluginListenerHandle;
  private NFCTagListener?: PluginListenerHandle;

  constructor(
    private apiHelper: InputAppAPIHelperUtil,
    private platform: Platform,
  ) {
    void this.#init();
  }

  #init(): void {
    this.platform.ready().then(async () => {
      await this.startNFCConnectionStateListener();
      await this.startNFCScannedDataListener();
    });
  }

  getNFCConnectionStateEmitterSubscription() {
    return this.NFCConnectionStateEmitter.asObservable();
  }

  getNFCScannedDataSubscription() {
    return this.NFCScannedData.asObservable();
  }

  async connectNFC(scanMode: TScanModes): Promise<boolean> {
    const res = await NFCReaderPlugin.connectNFC({scanMode});
    return res.status;
  }

  async disconnectNFC(): Promise<void> {
    await NFCReaderPlugin.disconnectNFC();
  }

  startNFCRead() {
    NFCReaderPlugin.startNFCRead().then((res) => {
      if (res.status) {
        console.log('Started Rfid read');
      } else {
        console.log('Failed to start Rfid read');
        this.apiHelper.showFailureToast("Failed to start Rfid read, please contact support!", true);
      }
    });
  }

  stopNFCRead() {
    NFCReaderPlugin.stopNFCRead().then((res) => {
      if (res.status) {
        console.log('stopped Rfid read');
      } else {
        console.log('Failed to stop Rfid read');
      }
    });
  }

  updateScanMode(scanMode: TScanModes) {
    return NFCReaderPlugin.updateScanMode({ scanMode: scanMode });
  }

  private async startNFCConnectionStateListener() {
    if (this.connectionListener) return;
    this.connectionListener = await NFCReaderPlugin.addListener(
      'connectionUpdateListener',
      (info: TNFCConnectionState) => {
        this.NFCConnectionStateEmitter.next(info);
      },
    );
  }

  private async startNFCScannedDataListener() {
    if (this.NFCTagListener) return;
    this.NFCTagListener = await NFCReaderPlugin.addListener('onNFCScanned', (info: { tagList: string[] }) => {
      this.NFCScannedData.next({
        tagList: info.tagList
      });
    });
  }
}
